import React, { Component } from 'react';

class TabBar extends Component {
  renderTabs(langs, current, switcher) {
    const tabs = [];

    for (const key in langs) {
      const tabName = langs[key];
      tabs.push(<li onClick={() => {switcher(key)}} className={current === key ? 'tab-bar__active-tab' : null} key={key}><i className="fa fa-file-code-o"></i> {tabName}</li>);
    }

    return tabs;
  }

  render() {
    return (
      <div className="tab-bar">
        <ul className="tab-bar__tabs-list">
          {this.renderTabs(this.props.langs, this.props.current, this.props.switcher)}
        </ul>
      </div>
    );
  }
}

export default TabBar;



// WEBPACK FOOTER //
// ./src/components/TabBar.js